import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './Header.css';
import logo from '../assets/logo.svg'; // Import the logo image

function Header() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [memberName, setMemberName] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dropdownRef = useRef(null);
  
  const [paymentRequired, setPaymentRequired] = useState(false);

  // Check authentication status on component mount
  useEffect(() => {
    const checkAuth = () => {
      // Check for token in localStorage or sessionStorage
      const token = localStorage.getItem('memberToken') || sessionStorage.getItem('memberToken');
      const name = localStorage.getItem('memberName');
      const paymentNeeded = localStorage.getItem('paymentRequired') === 'true';
      
      if (token) {
        setIsLoggedIn(true);
        setMemberName(name || 'Member');
        setPaymentRequired(paymentNeeded);
      } else {
        setIsLoggedIn(false);
        setMemberName('');
        setPaymentRequired(false);
      }
    };
    
    checkAuth();
    
    // Re-check auth status when localStorage changes
    window.addEventListener('storage', checkAuth);
    return () => {
      window.removeEventListener('storage', checkAuth);
    };
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef]);
  
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };
  
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };
  
  const handleLogout = () => {
    // Clear all member data
    localStorage.removeItem('authToken');
    localStorage.removeItem('memberToken');
    localStorage.removeItem('token');
    localStorage.removeItem('memberId');
    localStorage.removeItem('memberName');
    localStorage.removeItem('memberEmail');
    localStorage.removeItem('memberType');
    
    // Also clear from sessionStorage if it exists there
    sessionStorage.removeItem('memberToken');
    
    // Update state
    setIsLoggedIn(false);
    setMemberName('');
    setDropdownOpen(false);
    
    // Redirect to home page
    navigate('/');
  };
  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };
  
  return (
    <header className="header">
      <div className="logo-container">
        <Link to="/">
          <img src={logo} alt="BVA Logo" className="logo header-logo" />
        </Link>
      </div>
      
      <button className="mobile-menu-toggle" onClick={toggleMobileMenu} aria-label="Toggle navigation">
        {mobileMenuOpen ? '✕' : '☰'}
      </button>
      
      <nav className={`main-nav ${mobileMenuOpen ? 'show' : ''}`}>
        <ul>
          {isLoggedIn ? (
            paymentRequired ? (
              // Menu for unpaid members - only show payment link
              <li>
                <Link to="/complete-payment" className={isActive('/complete-payment')} onClick={() => setMobileMenuOpen(false)}>COMPLETE PAYMENT</Link>
              </li>
            ) : (
              // Menu for paid members
              <>
                <li><Link to="/programs" className={isActive('/programs')} onClick={() => setMobileMenuOpen(false)}>PROGRAMS</Link></li>
                <li><Link to="/professionals" className={isActive('/professionals')} onClick={() => setMobileMenuOpen(false)}>PROFESSIONALS</Link></li>
                <li><Link to="/member/profile" className={isActive('/profile')} onClick={() => setMobileMenuOpen(false)}>MY PROFILE</Link></li>
              </>
            )
          ) : (
            // Menu for logged-out users
            <>
              <li><Link to="/about-us" className={isActive('/about-us')} onClick={() => setMobileMenuOpen(false)}>ABOUT US</Link></li>
              <li><Link to="/programs" className={isActive('/programs')} onClick={() => setMobileMenuOpen(false)}>PROGRAMS</Link></li>
              <li><Link to="/membership" className={isActive('/membership')} onClick={() => setMobileMenuOpen(false)}>MEMBERSHIP</Link></li>
              <li><Link to="/office-bearers" className={isActive('/office-bearers')} onClick={() => setMobileMenuOpen(false)}>OFFICE BEARERS</Link></li>
              <li><Link to="/professionals" className={isActive('/professionals')} onClick={() => setMobileMenuOpen(false)}>PROFESSIONALS</Link></li>
              <li><Link to="/contact" className={isActive('/contact')} onClick={() => setMobileMenuOpen(false)}>CONTACT US</Link></li>
              <li><Link to="/gallery" className={isActive('/gallery')} onClick={() => setMobileMenuOpen(false)}>GALLERY</Link></li>
            </>
          )}
        </ul>
      </nav>
      
      <div className="header-buttons">
        {isLoggedIn ? (
          <div className={`member-dropdown ${dropdownOpen ? 'dropdown-active' : ''}`} ref={dropdownRef}>
            <button 
              className="dropdown-toggle"
              onClick={toggleDropdown}
              aria-expanded={dropdownOpen}
              aria-haspopup="true"
            >
              Hello, {memberName.split(' ')[0]}
            </button>
            <div className="dropdown-menu" aria-labelledby="member-dropdown">
              {paymentRequired ? (
                <Link to="/complete-payment" onClick={() => setDropdownOpen(false)}>Complete Payment</Link>
              ) : (
                <Link to="/member/profile" onClick={() => setDropdownOpen(false)}>My Profile</Link>
              )}
              <button onClick={handleLogout}>Logout</button>
            </div>
          </div>
        ) : (
          <>
            <Link to="/member-login">
              <button className="btn btn-light" style={{marginLeft: "10px"}}>MEMBER LOGIN</button>
            </Link>
            <Link to="/register">
              <button className="btn btn-primary">REGISTER</button>
            </Link>
          </>
        )}
      </div>
    </header>
  );
}

export default Header;